import { createFileRoute, Link } from '@tanstack/react-router'
import { ChevronLeft } from 'lucide-react'
import { Page } from '@/components/rm'
import { Chat } from '@/components/chat'
import { useThreadHeader } from '@/lib/messages'

// Spec 006. One conversation, business side.
export const Route = createFileRoute('/_app/inbox_/$id')({ component: BusinessConversation })

function BusinessConversation() {
  const { id } = Route.useParams()
  const header = useThreadHeader(id)
  const h = header.data
  if (!header.isLoading && !h) return <Page><p className="mt-5 text-[14px] text-token-secondary">Conversation not found.</p></Page>
  return (
    <Page>
      <Link to="/inbox" className="mt-1 inline-flex items-center gap-1 text-[13px] font-semibold text-token-secondary"><ChevronLeft className="h-4 w-4" />Messages</Link>
      <div className="mt-3 max-w-2xl space-y-3">
        <div className="rounded-[12px] border border-token-subtle bg-token-surface px-4 py-3">
          <p className="text-[16px] font-bold text-token-primary">{h?.counterpart ?? ''}</p>
          {h?.task_title && h.task_id && <Link to="/marketplace/$id" params={{ id: h.task_id }} className="text-[12.5px] text-token-secondary hover:underline">About: {h.task_title}</Link>}
        </div>
        <Chat threadId={id} mySide="business" labels={{
          placeholder: 'Write a message', send: 'Send',
          masked: 'Numbers, emails and links are hidden from the client until the booking is paid.',
          maskWarning: 'This looks like contact details. They will be hidden until the booking is paid.',
          photoProblem: 'The photo could not be sent. Use a JPG or PNG under 10 MB.', empty: 'No messages yet.',
        }} />
      </div>
    </Page>
  )
}
